
/* global femcare, Swiper */

femcare.shared.rangeSlider = {
    slider: null,
    nonMobileSliders: null,
    breakpoint: window.matchMedia('(min-width: 992px)'),

    init: function () {
        this.slider;
        this.nonMobileSliders = [];
        this.breakpoint.addEventListener('change', this.onResize.bind(this));

        this.initSlider();
    },

    initSlider: function () {
        var $range = $('.range-slider');
        var that = this;
        
        if ($range.length) {
            $range.each(function (index, element) {
                var $slider = $(element);
                var $spaceBetween = $slider.data('space-between');
                var isSliderOnMobie = $slider.data('mobile-slider');

                if(that.breakpoint.matches || isSliderOnMobie){
                    that.slider = new Swiper($slider.find('.swiper-container')[0], {
                        slidesPerView: 'auto',  
                        spaceBetween: $spaceBetween,
                        navigation: {
                            nextEl: $slider.find('.range-slider__next')[0],
                            prevEl: $slider.find('.range-slider__previous')[0]
                        },
                        mousewheel: {
                            forceToAxis: true
                        },
                        scrollbar: {
                            el: ".swiper-scrollbar"
                            },
                    });

                    if(!isSliderOnMobie){
                        that.nonMobileSliders.push(that.slider);
                    }
                } else if(that.nonMobileSliders.length){
                        that.nonMobileSliders.forEach(function (index, element) {
                            element.destroy(true, true);
                        }.bind(this));
                    }
                }
            );
        }
    },

    onResize: function () {
        if (this.breakpoint.matches){
            this.initSlider();
        } else {
            this.nonMobileSliders.forEach(function (slider) {
                slider.destroy(true, true);
            }.bind(this));

            this.sliders = [];
        }
    }
};